import { ASSISTANCE_SERVICE_ERROR_CODES } from '@atlassian/conversation-assistant-service-api/constants';
import { type StoreError } from '@atlassian/conversation-assistant-store/controllers/chat-signals';
import type { ChatGenericErrorType } from '@atlassian/conversation-assistant-ui-components/ui/ChatGenericError';

export const getChatGenericErrorType = (chatError: StoreError): ChatGenericErrorType => {
	if (
		chatError.message_template === ASSISTANCE_SERVICE_ERROR_CODES.ROVO_PRODUCT_NOT_ACTIVE ||
		chatError.message_template === ASSISTANCE_SERVICE_ERROR_CODES.HAS_HIPAA_ENABLED
	) {
		return 'rovo-inactive';
	}

	return chatError.status_code === 429 ? 'rate-limited' : 'generic';
};
